import React, { useState } from 'react';
import {
    Panel,
    PanelType,
    TextField,
    PrimaryButton,
    mergeStyleSets,
    IPanelStyles,
} from '@fluentui/react';
import LoaderComponent from '../loader/loader.component';
import ErrorMessageComponent from '../error-message/error-message.component';
import ApiService from '../../services/api/api.service';
import useAuthStatus from '../../hooks/auth/AuthHook';
import ItemTarea from '../../models/ItemTarea';

const panelStyles: IPanelStyles = {
    root: {}, overlay: {}, hiddenPanel: {}, main: {}, commands: { marginTop: 0 },
    contentInner: {}, scrollableContent: {},
    navigation: { backgroundColor: 'var(--color-primario)', padding: 10, alignItems: 'center' },
    header: { paddingLeft: 10, paddingRight: 10, paddingTop: 5, paddingBottom: 5 },
    headerText: { color: '#ffffff' },
    content: { padding: 0 },
    footer: {}, footerInner: {},
    subComponentStyles: {
        closeButton: {
            root: { color: '#ffffff', backgroundColor: 'transparent', padding: 0 },
            rootHovered: { backgroundColor: '#000000', color: '#ffffff', borderColor: '#000000' },
        },
    },
};

const formClasses = mergeStyleSets({
    sectionHeader: {
        display: 'block',
        backgroundColor: 'var(--color-primario)',
        color: 'white',
        padding: '4px 12px',
        fontWeight: 600,
        fontSize: '13px',
        marginBottom: '8px',
        marginTop: '12px',
    },
    fieldRow: { display: 'flex', alignItems: 'center', padding: '4px 12px', gap: 8 },
    fieldLabel: { minWidth: 100, fontSize: 13, color: '#333', fontWeight: 500 },
    fieldValue: { flex: 1 },
    footer: {
        padding: '12px',
        display: 'flex',
        justifyContent: 'flex-end',
        borderTop: '1px solid #ececec',
        marginTop: 8,
    },
    saveButton: {
        backgroundColor: 'var(--color-primario)',
        borderColor: 'var(--color-primario)',
    },
});

interface IWorkCobrosComponentProps {
    work: ItemTarea;
    onClose: () => void;
    onSaved?: () => void;
}

const WorkCobrosComponent = (props: IWorkCobrosComponentProps) => {
    const auth = useAuthStatus();
    const [importeCobro, setImporteCobro] = useState<string>(
        props.work.ImporteCobro ? props.work.ImporteCobro.toString() : ''
    );
    const [importeACobrar, setImporteACobrar] = useState<string>(
        props.work.ImporteACobrar ? props.work.ImporteACobrar.toString() : ''
    );
    const [conceptoCobro, setConceptoCobro] = useState<string>(props.work.ConceptoCobro || '');
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');

    const onSubmit = () => {
        if (!auth.user) return;
        setLoading(true);
        setError('');
        const params: any = {
            IdTarea: props.work.Id,
            ImporteCobro: parseFloat(importeCobro) || 0,
            ConceptoCobro: conceptoCobro,
        };
        if (importeACobrar !== '') {
            params.ImporteACobrar = parseFloat(importeACobrar) || 0;
        }
        ApiService.Post<string>('OrdenesTrabajo', 'SetValoresCobro', auth.user, params)
            .then(() => {
                if (props.onSaved) props.onSaved();
                props.onClose();
                setLoading(false);
            }, (err: string) => {
                setError(err);
                setLoading(false);
            });
    };

    return (
        <Panel
            isOpen={true}
            headerText="Cobros"
            onDismiss={props.onClose}
            styles={panelStyles}
            type={PanelType.smallFixedFar}>

            <span className={formClasses.sectionHeader}>Datos de cobro</span>

            <div className={formClasses.fieldRow}>
                <span className={formClasses.fieldLabel}>Importe cobrado</span>
                <div className={formClasses.fieldValue}>
                    <TextField
                        type="number"
                        value={importeCobro}
                        onChange={(_e, v) => setImporteCobro(v ?? '')} />
                </div>
            </div>

            <div className={formClasses.fieldRow}>
                <span className={formClasses.fieldLabel}>Importe a cobrar</span>
                <div className={formClasses.fieldValue}>
                    <TextField
                        type="number"
                        value={importeACobrar}
                        onChange={(_e, v) => setImporteACobrar(v ?? '')} />
                </div>
            </div>

            <div className={formClasses.fieldRow}>
                <span className={formClasses.fieldLabel}>Concepto</span>
                <div className={formClasses.fieldValue}>
                    <TextField
                        multiline
                        rows={3}
                        value={conceptoCobro}
                        onChange={(_e, v) => setConceptoCobro(v ?? '')} />
                </div>
            </div>

            <ErrorMessageComponent message={error} />

            <div className={formClasses.footer}>
                <PrimaryButton
                    text="Guardar"
                    className={formClasses.saveButton}
                    onClick={onSubmit} />
            </div>

            <LoaderComponent loading={loading} />
        </Panel>
    );
};

export default WorkCobrosComponent;
